import React from 'react'
import './loading.css'
const Loading = () => {
  return (
<div class="load-5">
   
    <h2><span>Loading</span>
<div class="ring-2">
  <div class="ball-holder">
    <div class="ball"></div>
  </div>
</div>
</h2> 
</div>
    
  )
}

export {Loading};